declare namespace $ {

	type $mol_view__sub_bog_smalljs_landing_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_landing_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_landing_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_landing_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_landing_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_8 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_10 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_12 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_text_code__text_bog_smalljs_landing_17 = $mol_type_enforce<
		ReturnType< $bog_smalljs_landing['code'] >
		,
		ReturnType< $bog_smalljs_text_code['text'] >
	>
	type $bog_smalljs_text_code__lang_bog_smalljs_landing_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_text_code['lang'] >
	>
	type $bog_smalljs_text_code__sidebar_showed_bog_smalljs_landing_19 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['sidebar_showed'] >
	>
	type $bog_smalljs_text_code__playground_showed_bog_smalljs_landing_20 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['playground_showed'] >
	>
	type $bog_smalljs_text_code__run_enabled_bog_smalljs_landing_21 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['run_enabled'] >
	>
	type $mol_view__sub_bog_smalljs_landing_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_text_code__text_bog_smalljs_landing_23 = $mol_type_enforce<
		ReturnType< $bog_smalljs_landing['code_ts'] >
		,
		ReturnType< $bog_smalljs_text_code['text'] >
	>
	type $bog_smalljs_text_code__lang_bog_smalljs_landing_24 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_text_code['lang'] >
	>
	type $bog_smalljs_text_code__sidebar_showed_bog_smalljs_landing_25 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['sidebar_showed'] >
	>
	type $bog_smalljs_text_code__playground_showed_bog_smalljs_landing_26 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['playground_showed'] >
	>
	type $bog_smalljs_text_code__run_enabled_bog_smalljs_landing_27 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['run_enabled'] >
	>
	type $mol_view__sub_bog_smalljs_landing_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_text_code__text_bog_smalljs_landing_29 = $mol_type_enforce<
		ReturnType< $bog_smalljs_landing['code_css'] >
		,
		ReturnType< $bog_smalljs_text_code['text'] >
	>
	type $bog_smalljs_text_code__lang_bog_smalljs_landing_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_text_code['lang'] >
	>
	type $bog_smalljs_text_code__sidebar_showed_bog_smalljs_landing_31 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['sidebar_showed'] >
	>
	type $bog_smalljs_text_code__playground_showed_bog_smalljs_landing_32 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['playground_showed'] >
	>
	type $bog_smalljs_text_code__run_enabled_bog_smalljs_landing_33 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_text_code['run_enabled'] >
	>
	type $mol_view__sub_bog_smalljs_landing_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_40 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
			'sample': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_smalljs_landing_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_smalljs_landing_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_smalljs_landing_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_smalljs_landing_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_smalljs_landing_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_smalljs_landing_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_landing_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_landing_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_structure__tree_bog_smalljs_landing_58 = $mol_type_enforce<
		ReturnType< $bog_smalljs_landing['arch_tree'] >
		,
		ReturnType< $bog_smalljs_structure['tree'] >
	>
	type $bog_smalljs_structure__steps_showed_bog_smalljs_landing_59 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_structure['steps_showed'] >
	>
	type $mol_link__arg_bog_smalljs_landing_60 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_65 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_smalljs_landing_67 = $mol_type_enforce<
		({ 
			'section': string,
			'a': string,
			'b': string,
			'page': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_landing_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_71 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_landing_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_73 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_75 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_76 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_77 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_79 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_80 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_81 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__sub_bog_smalljs_landing_82 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_landing_85 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_86 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_87 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_88 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_89 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_90 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__sub_bog_smalljs_landing_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_landing_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_95 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_96 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_landing_97 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_smalljs_landing_98 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_99 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_101 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_103 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_104 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_105 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_106 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_view__sub_bog_smalljs_landing_107 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_108 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_109 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_landing_110 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_111 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_112 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_113 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_114 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_115 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_116 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_117 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_118 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_119 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_120 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_121 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_122 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_123 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_124 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_smalljs_landing_125 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_landing_126 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_landing_127 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_view__sub_bog_smalljs_landing_128 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_129 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_130 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_131 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_132 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_133 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_landing_134 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_landing extends $mol_view {
		Hero_eyebrow_text( ): string
		Hero_eyebrow( ): $mol_view
		Hero_title_pre( ): string
		Hero_title_accent_text( ): string
		Hero_title_accent( ): $mol_view
		Hero_title_post( ): string
		Hero_title( ): $mol_view
		Hero_subtitle_text( ): string
		Hero_subtitle( ): $mol_view
		Hero_subtitle_note_text( ): string
		Hero_subtitle_note( ): $mol_view
		Hero_cta_start_label( ): string
		Hero_cta_start_icon( ): $mol_icon_arrow_right
		Hero_cta_start( ): $mol_link
		Hero_cta_play_label( ): string
		Hero_cta_play_icon( ): $mol_icon_open_in_new
		Hero_cta_play( ): $mol_link
		Hero_cta_why_label( ): string
		Hero_cta_why_icon( ): $mol_icon_arrow_right
		Hero_cta_why( ): $mol_link
		Hero_actions( ): $mol_view
		Hero_head( ): $mol_view
		Sign_code_label_text( ): string
		Sign_code_label( ): $mol_view
		code( ): string
		Sign_code_view( ): $bog_smalljs_text_code
		Sign_ts_label_text( ): string
		Sign_ts_label( ): $mol_view
		code_ts( ): string
		Sign_ts_view( ): $bog_smalljs_text_code
		Sign_css_label_text( ): string
		Sign_css_label( ): $mol_view
		code_css( ): string
		Sign_css_view( ): $bog_smalljs_text_code
		Sign_code( ): $mol_view
		Sign_arrow_text( ): string
		Sign_arrow( ): $mol_view
		Sign_live_label_text( ): string
		Sign_live_label( ): $mol_view
		Sign_demo( ): $bog_smalljs_demo
		Sign_live( ): $mol_view
		Sign_panel( ): $mol_view
		Sign_caption_text( ): string
		Sign_caption( ): $mol_view
		Sign_try_label( ): string
		Sign_try_icon( ): $mol_icon_open_in_new
		Sign_try( ): $mol_link
		Signature( ): $mol_view
		Hero( ): $mol_view
		Feature1_title_text( ): string
		Feature1_title( ): $mol_view
		Feature1_text( ): $mol_text
		Feature1( ): $mol_view
		Feature2_title_text( ): string
		Feature2_title( ): $mol_view
		Feature2_text( ): $mol_text
		Feature2( ): $mol_view
		Feature3_title_text( ): string
		Feature3_title( ): $mol_view
		Feature3_text( ): $mol_text
		Feature3( ): $mol_view
		Features( ): $mol_view
		arch_eyebrow_text( ): string
		Arch_eyebrow( ): $mol_view
		arch_title_text( ): string
		Arch_title( ): $mol_view
		arch_line_text( ): string
		Arch_line( ): $mol_view
		arch_tree( ): string
		Arch_structure( ): $bog_smalljs_structure
		arch_link_label( ): string
		Arch_link_icon( ): $mol_icon_arrow_right
		Arch_link( ): $mol_link
		Arch( ): $mol_view
		versus_eyebrow_text( ): string
		Versus_eyebrow( ): $mol_view
		versus_line_text( ): string
		Versus_line( ): $mol_view
		versus_open_label( ): string
		Versus_open_icon( ): $mol_icon_arrow_right
		Versus_open( ): $mol_link
		versus_pair_label( ): string
		Versus_pair( ): $mol_link
		Versus_links( ): $mol_view
		Versus( ): $mol_view
		Footer_sect_docs_title_text( ): string
		Footer_sect_docs_title( ): $mol_view
		Footer_link_quickstart( ): $mol_link
		Footer_link_guide( ): $mol_link
		Footer_link_tutorial( ): $mol_link
		Footer_link_examples( ): $mol_link
		Footer_link_api( ): $mol_link
		Footer_sect_docs( ): $mol_view
		Footer_col1( ): $mol_view
		Footer_sect_about_title_text( ): string
		Footer_sect_about_title( ): $mol_view
		Footer_link_faq( ): $mol_link
		Footer_link_team( ): $mol_link
		Footer_link_releases( ): $mol_link
		Footer_sect_about( ): $mol_view
		Footer_col2( ): $mol_view
		Footer_sect_resources_title_text( ): string
		Footer_sect_resources_title( ): $mol_view
		Footer_link_playground( ): $mol_link
		Footer_link_course( ): $mol_link
		Footer_link_ui( ): $mol_link
		Footer_link_telegram( ): $mol_link
		Footer_link_dev( ): $mol_link
		Footer_sect_resources( ): $mol_view
		Footer_col3( ): $mol_view
		Footer_sect_libs_title_text( ): string
		Footer_sect_libs_title( ): $mol_view
		Footer_link_wire( ): $mol_link
		Footer_link_fetch( ): $mol_link
		Footer_link_compare( ): $mol_link
		Footer_link_router( ): $mol_link
		Footer_link_crowd( ): $mol_link
		Footer_link_baza( ): $mol_link
		Footer_sect_libs( ): $mol_view
		Footer_col4( ): $mol_view
		Footer_cols( ): $mol_view
		Footer_copy_line1_text( ): string
		Footer_copy_line1( ): $mol_view
		Footer_copy_line2_text( ): string
		Footer_copy_line2( ): $mol_view
		Footer_copy( ): $mol_view
		Footer( ): $mol_view
		arch_label_workspace( ): string
		arch_label_registry( ): string
		arch_label_framework( ): string
		arch_label_package( ): string
		arch_label_registry_own( ): string
		arch_label_project( ): string
		arch_label_entry( ): string
		arch_label_tree( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=landing.view.tree.d.ts.map